var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"homePage",staticClass:"homePage",attrs:{"id":"homePage"}},[(!_vm.userInfo)?_c('div',{staticStyle:{"margin":"50vw auto","width":"max-content","height":"max-content","background":"var(--middleBlue)"},on:{"click":function($event){return _vm.goto('Login')}}},[_vm._v("Login\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a041924","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home/index.vue
// module id = null
// module chunks = 